module.exports = __webpack_public_path__ + "img/1 (74).2e3f7c9b.png";